export default () => {
    return {
        user: null,
    }
}
